import { TableCellDataType } from '@shared/components/table/table-cell/table-cell-data-type';
import { formatCellValue } from '@shared/components/table/table-cell/utils';
import { TableColumn } from '@shared/components/table/table.model';

export function getNestedValue(obj: unknown, path: string): unknown {
  if (!obj || !path) return undefined;

  return path.split('.').reduce((current: unknown, key) => {
    if (current === null || current === undefined) return undefined;
    if (typeof current !== 'object') return undefined;

    const record = current as Record<PropertyKey, unknown>;
    return record[key];
  }, obj);
}

export function renderValue<T>(row: T, column: TableColumn<T>, value: unknown): unknown {
  return column.renderHook ? column.renderHook(value, row) : value;
}

export function getCellValue<T>(row: T, column: TableColumn<T>): unknown {
  const keyStr = String(column.key);

  if (keyStr.includes('.')) {
    return renderValue(row, column, getNestedValue(row, keyStr));
  }

  return renderValue(row, column, (row as unknown as Record<string, unknown>)[keyStr]);
}

export function formatCellValueToString(
  value: unknown,
  type: TableCellDataType | undefined,
  currentLang?: string
): string {
  return formatCellValue(value, type, currentLang);
}
